var exports = {
  "buttonGroup": "buttonGroup-RGllW",
  "horizontal": "horizontal-RGllW",
  "floatRight": "floatRight-RGllW",
  "button": "button-RGllW",
  "circle": "circle-RGllW",
  "bordered": "bordered-RGllW",
  "inverted": "inverted-RGllW",
  "icon": "icon-RGllW",
  "disabled": "disabled-RGllW",
  "mini": "mini-RGllW",
  "tiny": "tiny-RGllW",
  "small": "small-RGllW",
  "large": "large-RGllW",
  "huge": "huge-RGllW",
  "giant": "giant-RGllW",
};

__webpack_require__.r(module.exports = exports);
